import { lazy } from 'react';
import { defineGlobalLayer } from '../shell/overlays';
import '../features/signatures/events';
export default defineGlobalLayer({
  id: 'signature-prepare',
  component: lazy(() => import('../features/signatures/PrepareSignature')),
});
